import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CUST, CUST_ANIM } from '../../../../theme/customizer-tokens';

export const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
`;

// Leading back affordance: a circular plate that steps the wizard back, matching
// the deploy step's review back button (and the mobile back arrow) so every back
// control in the customizer reads identically. Hidden on step 1, where there is
// nothing to go back to.
export const BackButton = styled.button`
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  border-radius: 9999px;
  display: grid;
  place-items: center;
  background: ${CUST.headerAvatarBg};
  color: ${CUST.white};
  cursor: pointer;
  transition: background ${CUST_ANIM.INTERACT_MS}ms ease;

  &:hover {
    background: ${CUST.headerAvatarBgHover};
  }
`;

export const Title = styled(Text)`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: ${CUST.white};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;